import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import api, { formatApiError } from "@/lib/api";

export function UndoSentDialog({ quotation, open, onOpenChange, onDone }) {
  const [reason, setReason] = useState("");
  const [saving, setSaving] = useState(false);
  useEffect(() => {
    if (open) setReason("");
  }, [open]);

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const r = await api.post(`/quotations/${quotation.id}/undo-sent`, { reason: reason.trim() });
      toast.success(`${r.data.display_number} returned to Draft`);
      onDone?.(r.data);
    } catch (err) { toast.error(formatApiError(err)); } finally { setSaving(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="undo-sent-dialog">
        <DialogHeader>
          <DialogTitle>Undo sent</DialogTitle>
          <DialogDescription>
            {quotation?.display_number} goes back to Draft. If this send moved the lead, its previous stage is restored, and any version it superseded becomes current again.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          <div>
            <Label className="text-xs font-semibold uppercase tracking-wider text-slate-500">Reason *</Label>
            <textarea required value={reason} onChange={(e) => setReason(e.target.value)} rows={3} placeholder="e.g. Marked by mistake, the client hasn't received it" className="mt-1 w-full border border-slate-200 rounded-md p-2 text-sm" data-testid="undo-sent-reason" />
          </div>
          <div className="flex justify-end gap-2">
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
            <Button type="submit" disabled={saving || !reason.trim()} className="bg-rose-600 hover:bg-rose-700" data-testid="undo-sent-confirm">{saving ? "Undoing…" : "Undo sent"}</Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}
